export default "__VITE_ASSET__a5a8ae4c__"